import { Component, Input, OnInit } from '@angular/core';
import { AchooBarChartComponent } from '../../../../core/achoo-bar-chart/achoo-bar-chart.component';
import { UserService } from '../../../../services/user.service';
import { BarChartData } from '../../../../../models/bar-chart-data';
import {CommonConstant} from '../../../../app.constants';

@Component({
  selector: 'demographic-bar-chart',
  templateUrl: './demographic-bar-chart.component.html',
  styleUrls: ['./demographic-bar-chart.component.scss']
})
export class DemographicBarChartComponent extends AchooBarChartComponent implements OnInit {

  @Input() maxValue: number;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.progressHeight = CommonConstant.DEMOGRAPHIC_BAR_CHART_PROGRESS_HEIGHT;
    this.borderRadius = CommonConstant.DEMOGRAPHIC_BAR_CHART_BORDER_RADIUS;
    while (this.series.length < this.maxLine) {
      this.series.push({
        title: null,
        value: 0,
        formattedValue: '-'
      });
    }
  }

  calculateProgressBar(value: number): number {
    if (this.maxValue) {
      return Math.round((value / this.maxValue) * 100);
    }
    return super.calculateProgress(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/demographic-bar-chart/demographic-bar-chart.component.ts